import React from 'react';
import { subscribe } from 'react-contextual';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;
const PartnerLogo = ({ w, subdomain, className, tenantConfig }) => (<img width={tenantConfig.header.logo.width || w} alt={'Logo'} src={`${config.cdnUrl}/static/images/wg/partners/logos/${subdomain}.png`} className={className} />)

export default subscribe()(PartnerLogo);
